import { axiosWithAuth } from "helpers";

export const applicationDocumentsService = {
	getDocuments,
	addDocument,
	viewDocument,
	downloadDocument,
	deleteDocument,
};

const API_URL = process.env.REACT_APP_API_URL;
const PAGE_SIZE = 50;

function getDocuments(applicationId, { page }, sortBy) {
	return axiosWithAuth({
		method: "GET",
		params: {
			ascending: sortBy?.desc,
			sort_type: sortBy?.id,
			page_index: page,
			page_size: PAGE_SIZE,
		},
		url: `${API_URL}/api/applications/${applicationId}/documents`,
	});
}

function addDocument(applicationId, document) {
	const formData = new FormData();
	const file = document.file;
	const extension = file.name.split(/[.]+/).pop();

	formData.append("file", file);
	formData.append("name", document.name);
	formData.append("extension", extension);
	formData.append("type", document.type);

	return axiosWithAuth({
		method: "POST",
		data: formData,
		url: `${API_URL}/api/applications/${applicationId}/documents`,
		headers: { "Content-Type": undefined },
	});
}

function deleteDocument(applicationId, documentId) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/applications/${applicationId}/documents/${documentId}`,
	};

	return axiosWithAuth(options);
}

async function viewDocument(applicationId, documentId) {
	try {
		let user = JSON.parse(localStorage.getItem("user") || "");
		window.open(
			`${API_URL}/api/applications/${applicationId}/documents/${documentId}/content?token=${user.access_token}`,
			"_blank",
		);
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}

function downloadDocument(applicationId, documentId) {
	try {
		let user = JSON.parse(localStorage.getItem("user") || "");
		const url = `${API_URL}/api/applications/${applicationId}/documents/${documentId}/content?download=true&token=${user.access_token}`;
		const link = document.createElement("a");
		link.href = url;
		link.click();
		return Promise.resolve();
	} catch {
		return Promise.reject();
	}
}
